export class DadosAula {
  visualizadas: number;
  total: number;
  porcentagem: number;
}
